import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import ServiceDetailsMain from './ServiceDetailsMain';
import Footer from '../../components/Footer';

const ServiceDetails = () => {
  return (
    <>
      <HeaderSeven />

      <ServiceDetailsMain />

      <Footer />
    </>
  );
};

export default ServiceDetails;
